<template>
  <div>
    <table-manager
    @filterChanged="filterChanged"
    @paginationChanged="paginationChanged"
    :options="options"
    @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="switches"
      :items="switches"
      :fields="switchesFields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :totalRows="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows"
      @input="inputSwitches"
      :perPage="perPage"
      v-model="currentPage"/>
    <b-modal size="lg" ref="addSwitch" hide-footer :title="$t('Switch')">
      <formAdd
      @hideAddSwitch="hideAddSwitch"
      :currentRowSwitch="currentRowSwitch"
      :isEdit="isEdit"/>
    </b-modal>
  </div>
</template>

<script>
import formAdd from './formAdd'

export default {
  components: {
    formAdd
  },
  data () {
    return {
      isEdit: null,
      currentRowSwitch: null,
      options: {
        isShowAddButton: true
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      switchesFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Switch name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    inputSwitches (numPage) {
      this.currentPage = numPage
      this.$store.dispatch('Inventory/GET_SWITCHES_PAGED', {page: this.currentPage, filter: this.filter, perPage: this.perPage})
    },
    showAdd () {
      this.currentRowSwitch = null
      this.isEdit = false
      this.$refs.addSwitch.show()
    },
    editItem (item) {
      this.currentRowSwitch = item
      this.currentRowSwitch.switch_id = item.id
      this.isEdit = true
      this.$refs.addSwitch.show()
    },
    hideAddSwitch () {
      this.$refs.addSwitch.hide()
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Switch"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Inventory/DELETE_SWITCHES', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Inventory/GET_SWITCHES_PAGED', {page: 1, filter: this.filter, perPage: this.perPage})
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
      this.$store.dispatch('Inventory/GET_SWITCHES_PAGED', {page: 1, filter: this.filter, perPage: this.perPage})
    },
    paginationChanged (value) {
      this.perPage = value
      this.$store.dispatch('Inventory/GET_SWITCHES_PAGED', {page: 1, filter: this.filter, perPage: this.perPage})
    }
  },
  watch: {
    switches: function (val) {
      this.totalRows = this.$store.getters['Inventory/SWITCHES_PAGED'].total_rows
    }
  },
  computed: {
    switches () {
      return this.$store.getters['Inventory/SWITCHES_PAGED'].switches
    }
  },
  async mounted () {
    await this.$store.dispatch('Inventory/GET_SWITCHES_PAGED', {page: 1, filter: this.filter, perPage: this.perPage})
    this.$store.dispatch('Inventory/GET_SWITCH_TYPES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/switches/main.vue